module.exports = __webpack_public_path__ + "static/media/ic-nav-forward.fc1fa786.svg";